import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MenuBar } from "../common/MenuBar";
import { Body } from "../common/Body";
import { useDispatch, useSelector } from "react-redux";
import { setHasUpdates, showPopup } from "../common/commonSlice";
import { PopupModalCentered } from "../../components/popups/PopupModalCentered";
import { getHolidays, getSettings } from "../settings/settingsSlice";
import { getTeams, setSelectedTeams } from "../../components/teams/teamsSlice";
import { getShiftSamples } from "../../components/scheduler/shifts/sampleShiftsSlice";
import { getLeaveSamples } from "../../components/scheduler/leave/leaveSampleSlice";
import { getUserSession } from "../login/loginSlice";
import { Footer } from "../common/Footer";
import { getDashboardData } from "../dashboard/dashboardSlice";
import UnreadNewsGate from "../dashboard/UnreadNewsGate";

export function HomePage() {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const urlParams = useParams()

  const settings = useSelector((state) => state.settings)
  const selectedDate = useSelector((state) => state.planning.selectedDate)
  const teams = useSelector((state) => state.teams.list)
  const myTeam = useSelector((state) => state.teams.myTeam)
  const popup = useSelector((state) => state.common.popup)
  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
  const defaultPage = useSelector((state) => state.common.defaultPage)
  const lastNewsId = useSelector((state) => state.dashboard.lastNewsId)
  const userToken = useSelector((state) => state.login.userToken)
  const newsList = useSelector((state) => state.dashboard.news)
  const [isVisible, setIsVisible] = useState(!document.hidden)
  // Nothing else is loaded until the server confirms the session: on an expired
  // session every request would otherwise fail with 401 in parallel.
  const [sessionChecked, setSessionChecked] = useState(false)

  const mounted = useRef(false)

  useEffect(() => {
    if (!sessionChecked) return
    let date = new Date(selectedDate)
    if (!settings.holidays[settings.selectedYear]) {
      dispatch(getHolidays({ year: settings.selectedYear }))
    }
    if (!settings.holidays[date.getFullYear()]) {
      dispatch(getHolidays({ year: date.getFullYear() }))
    }
    if (!settings.settingsList.length) {
      dispatch(getSettings())
    }
  }, [selectedDate, sessionChecked])

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      dispatch(getUserSession()).then(({ payload }) => {
        // Invalid session: networkManager already reset it and redirects to login
        if (!payload || payload.responseError) return
        dispatch(getShiftSamples())
        dispatch(getLeaveSamples())
        dispatch(getTeams())
        setSessionChecked(true)
      })
    }
    const intervalId = setInterval(() => {
      // if user logged in and screen visible keep loading dashboard every 10 seconds
      if (sessionChecked && userToken && isVisible) {
        dispatch(getDashboardData({ lastNewsId: lastNewsId }))
        const boolHasUpdates = Boolean(newsList?.some(item => item.seen === null))
        dispatch(setHasUpdates(boolHasUpdates))
      }
    }, 10000)

    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden)
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      clearInterval(intervalId)
    }
  })

  useEffect(() => {
    let selectedIds, useUrlParams
    if (teams && teams.length) {
      selectedIds = [teams[0].id]
      let availableTeams = teams.filter(team => {
        return team.id == urlParams.selectedTeamId
      })
      if (availableTeams.length) {
        useUrlParams = true
      }
    } else if (myTeam && (myTeam.userRoleId == 3 || !urlParams || (urlParams.view && urlParams.view.toLowerCase() != "groupes"))) {
      selectedIds = [myTeam.id]
      if (urlParams.selectedTeamId == myTeam.id) {
        useUrlParams = true
      }
    }

    if (selectedIds) {
      dispatch(setSelectedTeams(useUrlParams ? [parseInt(urlParams.selectedTeamId)] : selectedIds))
    }
  }, [teams, myTeam])

  useEffect(() => {
    if (selectedTeamsIds && selectedTeamsIds.length) {
      loadData()
    }
  }, [selectedTeamsIds])

  function loadData() {
    if (!selectedTeamsIds.length) return
    let view = urlParams.view || defaultPage
    let subView = urlParams.subView || 0
    let label = urlParams.label
    let selectedTeamId = selectedTeamsIds[0]
    navigate(`/${view}/${selectedTeamId}/${subView}${label != null ? `/${label}` : ''}`)
  }

  function setModalShow(show, type) {
    dispatch(showPopup({
      show: show,
      type: type
    }))
  }

  return (
    <div>
      <Body view={urlParams.view} />
      <MenuBar />
      <PopupModalCentered
        show={popup.show && popup.type === "CENTERED"}
        onHide={() => setModalShow(false)}
      />
      {/* Blocks the whole application until every unread news is confirmed */}
      <UnreadNewsGate />
    </div>
  )
}
